import { useEffect, useMemo, useState } from "react"
import { websiteBlob, websiteJson } from "../websiteApi"

function formatBytes(bytes){
const value = Number(bytes || 0)
if(value <= 0){
return "0 B"
}
const units = ["B","KB","MB","GB"]
let size = value
let unitIndex = 0
while(size >= 1024 && unitIndex < units.length - 1){
size = size / 1024
unitIndex += 1
}
return `${size.toFixed(size >= 10 || unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`
}

export default function Installers(){
const [installers,setInstallers] = useState([])
const [status,setStatus] = useState("Loading installers...")
const [downloadingId,setDownloadingId] = useState("")

const availableCount = useMemo(
()=>installers.filter(item=>item.available).length,
[installers]
)

useEffect(()=>{
websiteJson("/website/installers")
.then(data=>{
setInstallers(Array.isArray(data) ? data : [])
setStatus("")
}).catch(error=>{
setStatus(error.message || "Failed to load installer files")
})
},[])

const downloadInstaller = async(installer)=>{
if(!installer?.id){
return
}
setDownloadingId(installer.id)
setStatus("")
try{
const response = await websiteBlob(`/website/installers/${installer.id}/download`)
let filename = installer.download_filename || installer.filename || `agentcolab-${installer.id}`
const disposition = String(response.filenameHeader || "")
const match = disposition.match(/filename="?([^"]+)"?/)
if(match?.[1]){
filename = match[1]
}
const blobUrl = window.URL.createObjectURL(response.blob)
const anchor = document.createElement("a")
anchor.href = blobUrl
anchor.download = filename
document.body.appendChild(anchor)
anchor.click()
anchor.remove()
window.URL.revokeObjectURL(blobUrl)
setStatus(`Downloaded ${filename}`)
}catch(error){
setStatus(error.message || "Failed to download installer")
}finally{
setDownloadingId("")
}
}

return (
<div className="ac-page-frame">
<a href="/landing" style={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "13px", color: "var(--ac-primary)", textDecoration: "none", marginBottom: "16px" }}>
	&#8592; Back to Home
</a>
<h2 className="ac-page-title">Installer Downloads</h2>
<p className="ac-page-subtitle" style={{ maxWidth: "820px" }}>
Download the installer for your operating system. No account required.
</p>

<div style={{ marginTop: "14px", display: "grid", gap: "10px", gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))" }}>
<div className="ac-card" style={{ padding: "12px" }}>
<div style={{ fontSize: "12px", color: "var(--ac-text-muted)" }}>Available Installers</div>
<div style={{ fontSize: "24px", fontWeight: 800, color: "var(--ac-text)" }}>{availableCount}/3</div>
</div>
<div className="ac-card" style={{ padding: "12px" }}>
<div style={{ fontSize: "12px", color: "var(--ac-text-muted)" }}>Supported Platforms</div>
<div style={{ fontSize: "18px", fontWeight: 700, color: "var(--ac-text)" }}>Linux, macOS, Windows</div>
</div>
<div className="ac-card" style={{ padding: "12px" }}>
<div style={{ fontSize: "12px", color: "var(--ac-text-muted)" }}>Access</div>
<div style={{ fontSize: "18px", fontWeight: 700, color: "var(--ac-text)" }}>Open — No Login Required</div>
</div>
</div>

<div style={{ marginTop: "14px", display: "grid", gap: "12px" }}>
{installers.map((installer)=>(
<div key={installer.id} className="ac-card" style={{ padding: "14px" }}>
<div style={{ display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>
<div>
<h3 style={{ margin: "0 0 6px", color: "var(--ac-text)" }}>{installer.platform}</h3>
<div style={{ fontSize: "13px", color: "var(--ac-text-muted)" }}>{installer.description}</div>
<div style={{ marginTop: "6px", fontSize: "12px", color: "#334155" }}>
File: <code>{installer.download_filename || installer.filename}</code> ({formatBytes(installer.size_bytes)})
</div>
</div>
<button
onClick={()=>downloadInstaller(installer)}
disabled={!installer.available || downloadingId === installer.id}
className="ac-button ac-button--primary"
style={{ opacity: installer.available ? 1 : 0.7, minWidth: "150px" }}
>
{downloadingId === installer.id ? "Downloading..." : installer.available ? "Download" : "Not Available"}
</button>
</div>
</div>
))}
</div>

<div style={{ marginTop: "10px", minHeight: "18px", fontSize: "12px", color: "#334155" }}>
{status}
</div>
</div>
)
}
